module.exports = __webpack_public_path__ + "img/info-tip.80cc407b.svg";